import React from "react";
import { Typography, Skeleton } from "@mui/material";

/**
 * Props:
 * - text: le texte à afficher
 * - variant: h1, h2, body1, etc.
 * - loading: boolean pour afficher Skeleton
 * - responsive: boolean pour activer la taille responsive (optionnel)
 * - sx: styles supplémentaires
 */
export default function AppTypography({
  text,
  titre,
  variant = "body1",
  loading = false,
  responsive = true,
  sx = {},
  ...props
}) {
  if (loading) {
    return (
      <Skeleton
        variant="text"
        width="100%"
        sx={{
          fontSize: responsive
            ? { xs: "0.8rem", sm: "1rem", md: "1.2rem" }
            : undefined,
        }}
      />
    );
  }

  return (
    <Typography
      variant={variant}
      title={titre || text || ""}
      sx={{
        fontSize: responsive
          ? { xs: "0.8rem", sm: "1rem", md: "1.2rem" }
          : undefined,
        ...sx,
      }}
      {...props}
    >
      {text}
    </Typography>
  );
}
